export default "__VITE_ASSET__Cba2o2wj__"